export default ({ seeMoreLink }) => `
    <div class="HoldSuccessModal-relatedTitlesPrompt">${window.html(
        'holdSuccessModal.wantToBorrowSubheading'
    )}</div>

    <section class="relatedTitles"></section>

    <div class="HoldSuccessModal-callToActionContainer">
        <a class="button smaller primary radius HoldSuccessModal-callToAction" href="${seeMoreLink}">${window.html(
    'holdSuccessModal.showMore'
)}</a>
    </div>
`;
